import React from 'react';
import Contact from './Contact';
import Footer from './Footer';
import Fade from 'react-reveal';
import Timeline from './Timelines';
import './about.css'



export default function Pageabout(){
    return(
        <>
            <Fade top distance = '4%' duration = {2000}>
                <div className='aboutpage'>
                    <div className='hero'>
                        <h1>Hello</h1>
                        <h2>World</h2>
                        <img src= {require('./images/rishibw.png')}></img>
                    </div>
                    <div className='story'>
                        <p className='basic'>My name is Rishikesh Sarangan, and I'm a Web Developer from Bangalore. I am currently pursuing my BTech in Computer Science at SASTRA University.</p>
                        <p className='journey'>Learning Photoshop in my childhood induced the Designer in me and Programming in QBasic opened the world of Development. Both these worlds of mine converged, making me who I am today.</p>
                        <p className='hobbies'>In my spare time, I create Graphic Designs be it Cinematic or Promotional. Working out and Fitness has become a routine rather than a hobby. Besides that, I enjoy the world of Sitcoms and Fiction(The Office is my Favorite!). Practicality and Organisational skills are the ones I value and pride the most about.</p>
                    </div>
                    {/* <div className='photos'>

                    </div> */}
                    <Fade top distance = '10%' duration = {1000}>
                        <div className='education'>
                            <h1>Education</h1>
                            <Timeline />
                        </div>
                    </Fade>
                    <Fade top distance = '10%' duration = {1000}>
                    <div className='commonbox skills'>
                        <h1 className='boxheadings'>Skills</h1>
                        <ul className='items'>
                            <li>C++</li>
                            <li>Python</li>
                            <li>React JS</li>
                            <li>Node JS</li>
                            <li>MongoDB</li>
                            <li>Photoshop</li>
                        </ul>
                    </div>
                    </Fade>
                </div>
                <Contact />
                <Footer />
            </Fade>
        </>
    );
}